import { Data } from './data';
import { Partenaire } from './partenaire';
import { EnregistrementInventaire } from './enregistrementinventaire';
import { CatProduit } from './catproduit';
import { ApiFile } from './apifile';

export class Produit extends Data {

    designation: string;
    code_produit: string;
    frss: string;
    type: string;
    famille: string;
    prix_achat: number;
    prix_intermediaire: number;
    prix_detail: number;
    prix_de_gros: number;
    description: Text;
    fournisseurs: Partenaire[];
    categories: CatProduit[];
    is_emballage: Boolean;
    emballage: Produit;

    is_stockable: Boolean;

    tva: number;

    stockmin: number;
    nature: string;

    // variable pour la gestion de stock
    unite: string;
    stockreel: number;
    last_inventory: EnregistrementInventaire;
    date_last_inventory: string;
    achats: number;
    entrees_from: number;
    sorties_from: number;

    // variable pour la gestion des etats de commandes ventes et achats
    montant_ventes: number;
    ventes: number;
    commandes: number;
    commandes_net: number;
    montant_commandes: number;
    montant_commandes_net: number;
    retour_client: number;
    retour_fournisseur: number;
    retour: number;
    stock: number;
    tva_achat: number;
    type_calcul_tva_achat: string;
    type_calcul_tva_vente: string;
    images: ApiFile[];
    image_principale: ApiFile;
    commande_is_activate: boolean; 
    sell_in_ligne: boolean;
    is_promo: boolean;
    prix_promo: number;

    fichier_telechargeable: ApiFile;
    is_publish: boolean;
    other_file;

    external_link: string;
    is_external_link: boolean;

    constructor() {
        super(); // on appelle le constructeur du parent;
        this.prix_achat = 0;
        this.prix_detail = 0;
        this.is_emballage = false;
        this.is_stockable = true;
        this.nature = 'article';
        this.stock = 0;
        this.stockmin = 0;
        this.type_calcul_tva_achat = 'pourcentage';
        this.type_calcul_tva_vente = 'pourcentage';
        this.commande_is_activate = true; 
        this.sell_in_ligne = true;
        this.is_publish = false;
    }


    get formatDateLastInventory(): string {

        // return this.entrees - this.sorties;
        // return this.stockjour - this.ventes;
        return this.formatDate( this.date_last_inventory);
    }

    get nomFournisseur(): string {

        let name = '';

        if (this.fournisseurs !== undefined && this.fournisseurs !== undefined !== null) {

            for (let i = 0; i < this.fournisseurs.length; i++) {
                name += ''  + this.fournisseurs[i].nom + '<hr> ';
            }
        }

        return name;

    }

    get nomFamilles(): string {

        let name = '';

        if (this.categories !== undefined && this.categories !== undefined !== null) {

            for (let i = 0; i < this.categories.length; i++) {
                // name += ''  + this.categories[i].nom + '<hr> ';
                name += ''  + this.categories[i].nom;
            }
        }

        return name;

    }

    get quantite(): number {

        // return this.entrees - this.sorties;
        // return this.stockjour - this.ventes;
        return this.entrees - this.sorties;
    }

    get sorties(): number {

        return this.ventes + this.retour_fournisseur;
        // return this.stockjour - this.ventes;
        // return this.stockjour - ( this.sorties - this.retour_client );
    }

    get valorisationStock(): number {

        return this.quantite * this.prix_achat;

    }

    get stockinit(): number {

        let Stockinitlastinventory = 0;

        if (this.last_inventory !== null && this.last_inventory !== undefined)
        // Stockinitlastinventory = Number(this.last_inventory.stockinitial);
        return Stockinitlastinventory = Number(this.last_inventory.stockreel);
        else {// cas ou aucun inventaire n'a été fait le stock initial sera egale au stock lors de la creation du produit
            Stockinitlastinventory = this.stock - ( this.achats + this.retour_client) + this.sorties;
            return Stockinitlastinventory;
        }

        // return Stockinitlastinventory + this.entrees_from - this.sorties_from;

    }

    get entrees(): number {

        return this.stockinit + this.achats + this.retour_client;

    }

    get entreesJour(): number {

        return this.achats + this.retour_client;

    }

    get ecart(): number {

        if ( this.stockreel === undefined || this.stockreel === null)
        this.stockreel = 0;

        return this.stockreel - this.quantite;

    }


    get valorisationStockReel(): number {

        if ( this.stockreel === undefined || this.stockreel === null)
        this.stockreel = 0;

        return this.stockreel * this.prix_achat;

    }

    get valorisationEcart(): number {

        return this.ecart * this.prix_achat;
    }

    get montantTVA(): number {
        if (this.tva === null || this.tva === undefined)
        return 0;
        else {

            if (this.type_calcul_tva_vente === 'pourcentage')
            return (this.prix_detail * this.tva) / 100;
            else 
            return this.tva;
        }
        
    }

    get montantTVAAchat(): number {
        if (this.tva_achat === null || this.tva_achat === undefined)
        return 0;
        else {

            if (this.type_calcul_tva_achat === 'pourcentage')
            return (this.prix_achat * this.tva_achat) / 100;
            else
            return this.tva_achat;
        }
        
    }

    get prixTotal(): number {
        return this.prix_detail + this.montantTVA;
    }

    get prixTotalAchat(): number {
        return this.prix_achat + this.montantTVAAchat;
    }

    get etatCommande(): string {

        if(this.commande_is_activate)
        return 'Oui';
        else
        return 'Non'; 

    }

    get etatPromo(): string {

        if(this.is_promo)
        return 'Oui';
        else
        return 'Non';

    }

    get etatVente(): string {
        if(this.sell_in_ligne)
        return 'Oui';
        else
        return 'Non';
    }

    get etatGestionStock(): string {

        if(this.is_stockable)
        return 'Oui';
        else
        return 'Non';

    }


}
